import { Button, Form, Input, Modal, notification } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePasswordResetMutation } from '../../../features/auth/authApi';

const ResetPasswordModal = ({ isOpen, onCancel }) => {
    const { t } = useTranslation();
    const [resetPassword, {}] = usePasswordResetMutation();

    const onOk = (values) => {
        resetPassword(values)
            .unwrap()
            .then((res) => {
                notification.success({
                    message: t('resetPassword.header'),
                    description: t(
                        'resetPassword.success'
                    ),
                });
                onCancel();
            })
            .catch((err) => {
                notification.error({
                    message: t('resetPassword.header'),
                    description: t(
                        'resetPassword.error'
                    ),
                });
                onCancel();
            });
    };

    return (
        <Modal
            title={t('resetPassword.header')}
            open={isOpen}
            onOk={onOk}
            onCancel={onCancel}
            footer={null}
            width={500}
        >
            <Form
                name="reset-password"
                initialValues={{ remember: true }}
                onFinish={onOk}
                layout="vertical"
            >
                <Form.Item
                    label={t('resetPassword.email')}
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: t('resetPassword.emailMissingWarning') as string,
                        },
                    ]}
                >
                    <Input data-cy="reset-password-email" />
                </Form.Item>
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        data-cy="reset-password-submit"
                    >
                        {t('resetPassword.submit')}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ResetPasswordModal;
